import gql from 'graphql-tag';

const DELETE_BILLING_TEMPLATE = gql`
  mutation deleteBillingTemplate($input: BillingTemplateIdentifierInput!) {
    deleteBillingTemplate(input: $input)
  }
`;

const CREATE_BILLING_TEMPLATE = gql`
  mutation createBillingTemplate($input: CreateBillingTemplateInput!) {
    createBillingTemplate(input: $input) {
      templateId
      name
      description
    }
  }
`;

const UPDATE_BILLING_TEMPLATE = gql`
  mutation updateBillingTemplate($input: UpdateBillingTemplateInput!) {
    updateBillingTemplate(input: $input) {
      templateId
      name
      description
    }
  }
`;

export {
  CREATE_BILLING_TEMPLATE,
  UPDATE_BILLING_TEMPLATE,
  DELETE_BILLING_TEMPLATE
};
